import ReactConfetti from 'react-confetti'

export const Confetti = ({ height = 0, width = 0, shouldRun = false }) => {
  return (
    <ReactConfetti
      aria-hidden={true}
      colors={['#3F9FEB', '#C331B6', '#30C434', '#F1CE31', '#EE3B7C']}
      confettiSource={{
        x: width / 2,
        y: height / 2,
        w: 20,
        h: 20,
      }}
      gravity={0.05}
      height={height}
      initialVelocityX={7}
      initialVelocityY={8}
      numberOfPieces={200}
      recycle={false}
      run={shouldRun}
      style={{ inset: 'auto' }}
      width={width}
    />
  )
}
